var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2E5FCA",
  stroke: "#2E5FCA",
  strokeWidth: 0.3,
  d: "M1.002 10.008c.025.43.31.79.722.913l7.624 2.305.28 5.256a.52.52 0 0 0 .522.488c.149 0 .29-.06.391-.174l2.696-2.984 3.82 2.644c.17.12.37.183.578.183.48 0 .896-.34.997-.815l3.172-16.162a.52.52 0 0 0-.705-.581L1.613 9.01a1.02 1.02 0 0 0-.611.997zm9.594 7.17-.174-3.315 1.953 1.35zm7.022.404-6.954-4.814 9.752-9.433zm1.728-14.663-9.641 9.327-7.616-2.301z"
})));
export default SvgSend;